import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const purchases = [{
  name: 'Fernando G.',
  location: 'La Plata'
}, {
  name: 'Alejandro M.',
  location: 'Salta'
}, {
  name: 'Diego R.',
  location: 'Mar del Plata'
}, {
  name: 'Pablo S.',
  location: 'Neuquén'
}, {
  name: 'Martín L.',
  location: 'Chaco'
}, {
  name: 'Gustavo T.',
  location: 'San Juan'
}];
export function FloatingNotifications() {
  const [visibleIndex, setVisibleIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setVisibleIndex(prev => (prev + 1) % purchases.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return <div className="fixed bottom-4 left-4 z-50 max-w-[260px] pointer-events-none" data-id="element-122">
      <AnimatePresence mode="wait" data-id="element-123">
        <motion.div key={visibleIndex} initial={{
        opacity: 0,
        y: 15,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -10,
        scale: 0.95
      }} transition={{
        duration: 0.3
      }} className="bg-white border border-gray-200 shadow-xl p-2.5 flex items-center gap-3 pointer-events-auto" data-id="element-124">
          <div className="bg-green-100 p-1.5 rounded-sm flex-shrink-0" data-id="element-125">
            <ShoppingBag className="w-4 h-4 text-green-600" data-id="element-126" />
          </div>
          <div className="min-w-0" data-id="element-127">
            <p className="font-bold text-matte text-xs leading-tight truncate" data-id="element-128">
              {purchases[visibleIndex].name}{' '}
              <span className="font-normal text-gray-500" data-id="element-129">
                ({purchases[visibleIndex].location})
              </span>
            </p>
            <p className="text-[10px] text-green-600 font-bold uppercase tracking-wide mt-0.5" data-id="element-130">
              Compró hace minutos
            </p>
          </div>
        </motion.div>
      </AnimatePresence>
    </div>;
}